import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { useEffect, useState } from 'react';

/**
 * Check if the flex (`flex-direction: row`) element is displayed in two or more lines (wrapped).
 *
 * WARNING: Use this hook carefully!
 *          This hook works only for flex elements with `flex-direction: row` and
 *          if child elements have the same `offsetTop` position when they are in the one row.
 *          If you have a different layout, this hook may not work correctly.
 */
export function useIsFlexElementWrapped() {
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    element = _useState2[0],
    setElement = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    result = _useState4[0],
    setResult = _useState4[1];
  useEffect(function () {
    if (!element) {
      return;
    }
    var updateResult = function updateResult(entries) {
      var _iterator = _createForOfIteratorHelper(entries),
        _step;
      try {
        var _loop = function _loop() {
            var entry = _step.value;
            var firstChild = entry.target.firstElementChild;
            if (!(firstChild instanceof HTMLElement)) {
              setResult(false);
              return {
                v: void 0
              };
            }
            var firstChildTop = firstChild.offsetTop;

            // Check that all elements in the same row, if not, set result to true.
            // We can't check the first and last element because the may have different visual position,
            // because of order CCS property.
            var isInTwoLine = Array.from(entry.target.children).some(function (child) {
              return child instanceof HTMLElement && child.offsetTop !== firstChildTop;
            });
            setResult(isInTwoLine);
          },
          _ret;
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          _ret = _loop();
          if (_ret) return _ret.v;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    };
    var resizeObserver = new ResizeObserver(updateResult);
    resizeObserver.observe(element);
    return function () {
      resizeObserver.disconnect();
    };
  }, [element]);
  return [setElement, result];
}